import React from "react";

interface LoadingStateProps {
  isLoading?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ isLoading = true }) => (
  <div className={` ${isLoading ? "" : "hidden"}`} data-test-id="buy-box-loading-state">
    <div className="animate-pulse flex flex-col h-full w-full gap-4">
      <div className="h-14 w-full bg-offWhite rounded" />
      <div className="h-14 w-full bg-offWhite rounded" />
      <div className="h-14 w-full bg-offWhite rounded" />
    </div>
  </div>
);

export default LoadingState;
